import { controllerFactory } from "@utils/createController";

export default class extends controllerFactory()({
  targets: { appendTarget: null, row: null, template: HTMLTemplateElement },
}) {
  /**
   * We need to do 2 simple things:
   * 1. clone the node from template
   * 2. set the correct names to all important inputs in the form of `invitations[<index>][<fieldName>]`
   */
  clone() {
    const clone = document.importNode(this.templateTarget.content, true);

    const index = this.rowTargets.length,
      baseName = `invitations[${index}]`;

    clone.querySelector<HTMLInputElement>(
      "input[data-js-target='input']",
    )!.name = `${baseName}[email]`;

    clone.querySelector<HTMLInputElement>(
      "select[data-js-target='select']",
    )!.name = `${baseName}[role]`;

    this.appendTargetTarget.appendChild(clone);
  }

  connect() {
    this.clone();
  }
}
